export default {
    header: `Get the latest communications from RSi of IRI. In this section, check the announcement types which you would like to receive email alerts.`
}